import PageDataset from './PageDataset';
import * as d3 from 'd3';
import numeral from "numeral";

const PageActionRecommender = {
  defaultConfig: {

  },

  empty: {
    pageValuePotential: 0,
    messages: [{
      page: '/home',
      title: 'increase visits',
      description: 'you need to increase visits because reasons',
    }],
  },

  getRecommendations: function (page, contentItem) {

    // let MatrixService;
    // if (process.env.NODE_ENV === "development") {
    //   MatrixService = require("../data/MatrixService.dev").default;
    // } else {
    //   MatrixService = require("../data/MatrixService.prod").default;
    // }

    // let PageMetricsService;
    // if (process.env.NODE_ENV === "development") {
    //   PageMetricsService = require("../data/PageMetricsService.dev").default;
    // } else {
    //   PageMetricsService = require("../data/PageMetricsService.prod").default;
    // }

    // //TODO:
    // let site = '';
    // let dateRange = {};
    // let dataset = MatrixService.getMetrics(dateRange, site);

    let dataset = PageDataset.getData();

    let averageVpV = d3.mean(dataset, p => p.valuePerVisit);
    let averageVisits = d3.mean(dataset, p => p.visits);

    //build messages
    let messages = [];
    let p = this.calculatePageValuePotential(averageVpV, page);
    if (p.messages !== null) {
      messages.push(p.messages);
    }

    let qmessages = this.getMessagesByQuandrant(averageVpV, averageVisits, page);
    if (qmessages != null) {
      messages = messages.concat(qmessages);
    }

    return {
      pageValuePotential: p.potential,
      messages: messages
    };
  },

  calculateQuadrant(averageVpV, averageVisits, page) {
    let visitsPosition = page.visits <= averageVisits ? "bottom" : "top";
    let valuePostion = page.valuePerVisit <= averageVpV ? "left" : "right";
    return visitsPosition + valuePostion;
  },

  getMessagesByQuandrant(averageVpV, averageVisits, page) {
    let quandrant = this.calculateQuadrant(averageVpV, averageVisits, page);

    switch (quandrant) {

      case "topleft":
        return this.createMessagesForLowValueHighVisitPages(averageVpV, averageVisits, page);

      case "topright":
        return null;

      case "bottomleft":
        return [
          this.createRecommendationMessage(`Pages performing poorly`, `Review pages to determine if they're required`, page)
        ];

      case "bottomright":
        return [
          this.createRecommendationMessage(`You are ${numeral(averageVisits - page.visits).format("0,0")} under average visit count`, `Increase traffic to page by reviewing SEO and other traffic sources`, page)
        ];
      default:
        return [this.createRecommendationMessage("", "Cannot determine quandrant: ¯\_(ツ)_/¯", page)];
    }
  },

  createMessagesForLowValueHighVisitPages(averageVpV, averageVisits, page) {
    let messages = [];

    messages.push(this.createRecommendationMessage("Below averagevalue per visit", `You're ${numeral(averageVpV - page.valuePerVisit).format("0,0")} points below the average VpV.  Ensure content matches your intended audience by adding personalization and reviewing the expected profile`, page));

    if (page.personalizationDetails && page.personalizationDetails.isUsingPersonalization) {
      //show the conditions
      let names = page.personalizationDetails.renderingRulesets.map(r => r.name).join(",");
      let messageText = `Personalization is enabled with the following rulesets ${names} but they're not effective.  Consider changing content or running an A/B test.`;
      let msg = this.createRecommendationMessage("Review personalization conditions", messageText, page);
      messages.push(msg);
    }
    else {
      let pmsg = this.createRecommendationMessage(`Missing personalization ¯\_(ツ)_/¯`, `We see that personalization is not running on this page.  Adding it is proven to increase page value`, page);
      messages.push(pmsg);
    }

    return messages;
  },

  createRecommendationMessage(title, messageText, page) {
    return {
      title: title,
      messageText: messageText,
      page: page
    };
  },


  calculatePageValuePotential(averageVpV, page) {
    let diff = page.valuePerVisit - averageVpV;

    //only show page potential if we are under the average VpV
    let potential = diff > 0 ? 0 : Math.abs(diff) * page.visits;
    return {
      potential: potential,
      messages: potential <= 0 ? null : this.createRecommendationMessage("Increase page value", `You have a potential of ${numeral(potential).format("0,0")} engagement points.`, page)
    };
  }


};

export default PageActionRecommender;


// WEBPACK FOOTER //
// ./src/components/PageActionRecommender.js